import React, { memo } from 'react';

import { LanguageSwitcher, Help, WorkerMenu, AdminMenu } from './components';
import { ReactComponent as FcaLogo } from 'assets/icons/FcaLogoBlue.svg';
import { ReactComponent as InternetConnectedIcon } from 'assets/icons/InternetConnected.svg';
import { ReactComponent as InternetDisconnectedIcon } from 'assets/icons/InternetDisconnected.svg';
import OnlineOnlyPageWarning from 'modules/views/shared/OnlineOnlyPageWarning';

import { useAppSelector } from 'modules/state-mgmt/store';

import { useStyles } from './styles';

export interface IHeaderProps {
  hasLoginButton?: boolean;
  styleClass?: string;
  showOnlineWarning?: boolean;
  warningText?: React.ReactNode;
  warningIcon?: React.ReactNode;
  /**
   * Opt-in: render as a full-width white bar with the FCA logo on the left and
   * controls on the right (used by the SelectProject floating-card layout).
   * Defaults to false so every other screen keeps the existing top-right header.
   */
  fullWidthHeader?: boolean;
}

const Header = ({ styleClass = '', showOnlineWarning, warningText, warningIcon, fullWidthHeader }: IHeaderProps) => {
  const classes = useStyles();
  const { user, isOnline } = useAppSelector(state => ({
    user: state.user,
    isOnline: state.app.isOnline,
  }));

  return (
    <div className={`${classes.headerWrapper} ${fullWidthHeader ? classes.headerWrapperFull : ''} ${styleClass}`}>
      <div id="app-header" className={`${classes.header} ${fullWidthHeader ? classes.headerFull : ''}`}>
        <FcaLogo className={`${classes.fcaIcon} ${fullWidthHeader ? classes.fcaIconVisible : ''}`} />
        <div className={classes.headerRightSection}>
          {!user?.isWorker &&
            (isOnline ? (
              <InternetConnectedIcon className={classes.internetIcon} />
            ) : (
              <InternetDisconnectedIcon className={classes.internetIcon} />
            ))}
          <LanguageSwitcher />
          <Help isAuthenticated={!!user?.userId} />
          {/* {hasLoginButton && !user.userId && (
            <Button
              label={
                <>
                  <LoginIcon className={classes.loginIcon} />
                  {t('login.buttons.login')}
                </>
              }
              styleClass={classes.loginButton}
              onClick={() => navigate(ROUTES.LOGIN.path)}
            />
          )} */}
          {user?.userId && (user?.isWorker ? <WorkerMenu /> : <AdminMenu />)}
        </div>
      </div>
      {showOnlineWarning && <OnlineOnlyPageWarning styleClass={classes.warningBar} text={warningText} icon={warningIcon} />}
    </div>
  );
};

export default memo(Header);
